import { useCallback, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import useOnboardingProcess from '@hooks/useOnboardingProcess';
import { useResponsive } from '@hooks/useResponsive';

export default function useMediaViewerAnnouncementMobileTour({
  isAssetReady,
  isPreparing,
  isUnsupported
}: {
  isAssetReady: boolean;
  isPreparing: boolean;
  isUnsupported: boolean;
}) {
  const { isLgWidth } = useResponsive();
  const { onStartTour } = useOnboardingProcess();
  const [searchParams] = useSearchParams();
  const startTour = searchParams.get('startTour');

  const onStartTourAnnouncement = useCallback(() => {
    onStartTour({
      type: 'announcement-media-viewer-mobile'
    });
  }, [onStartTour]);

  useEffect(() => {
    if (isLgWidth) return;
    if (startTour !== 'announcement-media-viewer-mobile') return;
    if (isUnsupported) return;
    if (isPreparing) return;
    if (!isAssetReady) return;
    onStartTourAnnouncement();
  }, [
    startTour,
    isLgWidth,
    isAssetReady,
    isPreparing,
    isUnsupported,
    onStartTourAnnouncement
  ]);

  return null;
}
